// import React, { useState, useEffect, useRef } from 'react';
// import Editor from '@monaco-editor/react';


// function JavaCompiler() {
//   const [javaCode, setJavaCode] = useState(`public class Main {
//     public static void main(String[] args) {
//         System.out.println("Hello from Codii!");
//         int result = fibonacci(10);
//         System.out.println("Fibonacci(10) = " + result);
//     }
    
//     public static int fibonacci(int n) {
//         if (n <= 1) return n;
//         return fibonacci(n - 1) + fibonacci(n - 2);
//     }
// }`);
  
//   const [jsOutput, setJsOutput] = useState('');
//   const [consoleOutput, setConsoleOutput] = useState('');
//   const [status, setStatus] = useState('Loading...');
//   const [isInitialized, setIsInitialized] = useState(false);
//   const [canRun, setCanRun] = useState(false);
  
//   const compilerRef = useRef(null);

//   const editorOptions = {
//     autoIndent: 'full',
//     fontFamily: 'JetBrains Mono, Fira Code, monospace',
//     fontSize: 14,
//     lineHeight: 22,
//     minimap: { enabled: false },
//     automaticLayout: true,
//     scrollBeyondLastLine: false,
//     padding: { top: 16, bottom: 16 },
//   };

//   const addToConsole = (text) => {
//     setConsoleOutput(prev => prev + text);
//   };

//   useEffect(() => {
//     const initializeTeaVM = async () => {
//       setStatus('Loading...');
//       addToConsole('Setting Up Connection...\n');
      
//       try {
//         addToConsole('Loading WebAssembly module...\n');
//         const { load } = await import('./c.js');
//         const teavm = await load('/compiler.wasm');
//         const compilerLib = teavm.exports;
//         addToConsole('WebAssembly module loaded successfully\n');
        
//         addToConsole('Creating compiler instance...\n');
//         compilerRef.current = compilerLib.createCompiler();
//         addToConsole('Compiler instance created\n');
        
//         setStatus('Loading SDK...');
//         addToConsole('Loading SDK from compile-classlib-teavm.bin...\n');
//         let response = await fetch('/compile-classlib-teavm.bin');
//         if (!response.ok) {
//           throw new Error(`Failed to load SDK: ${response.status} ${response.statusText}`);
//         }
//         let arrayBuffer = await response.arrayBuffer();
//         addToConsole(`SDK loaded: ${arrayBuffer.byteLength} bytes\n`);
//         compilerRef.current.setSdk(new Uint8Array(arrayBuffer));
//         addToConsole('SDK set successfully\n');
        
//         setStatus('Loading runtime...');
//         addToConsole('Loading runtime from runtime-classlib-teavm.bin...\n');
//         response = await fetch('/runtime-classlib-teavm.bin');
//         if (!response.ok) {
//           throw new Error(`Failed to load runtime: ${response.status} ${response.statusText}`);
//         }
//         arrayBuffer = await response.arrayBuffer();
//         addToConsole(`Runtime loaded: ${arrayBuffer.byteLength} bytes\n`);
//         compilerRef.current.setTeaVMClasslib(new Uint8Array(arrayBuffer));
//         addToConsole('Runtime set successfully\n');
        
//         setStatus('Ready to compile!');
//         addToConsole('Initialization complete! Ready to compile Java code.\n');
//         setIsInitialized(true);
        
//       } catch (error) {
//         setStatus('Error: ' + error.message);
//         addToConsole('Initialization error: ' + error.message + '\n');
//         addToConsole('Stack trace: ' + error.stack + '\n');
//         console.error('Initialization error:', error);
//       }
//     };
    
//     initializeTeaVM();
//   }, []);

//   const compileJava = async () => {
//     if (!isInitialized) {
//       alert('Connection not ready yet. Please wait for initialization.');
//       return;
//     }
    
//     const compiler = compilerRef.current;
//     setStatus('Compiling...');
//     setConsoleOutput('Starting compilation...\n');
    
//     try {
//       const diagnostics = [];
//       const listener = compiler.onDiagnostic ? compiler.onDiagnostic((diagnostic) => {
//         diagnostics.push(diagnostic);
//         addToConsole(`[${diagnostic.severity}] ${diagnostic.fileName}:${diagnostic.lineNumber} - ${diagnostic.message}\n`);
//       }) : null;
      
//       compiler.clearSourceFiles();
//       compiler.addSourceFile('Main.java', javaCode);
      
//       addToConsole('Source file added, compiling Java...\n');
      
//       const compileResult = compiler.compile();
      
//       addToConsole(`Java compilation result: ${compileResult}\n`);
      
//       if (compileResult) {
//         addToConsole('Generating WebAssembly and trying to execute...\n');
        
//         try {
//           compiler.generateWebAssembly({
//             outputName: "app",
//             mainClass: "Main"
//           });
//           addToConsole('WebAssembly generation completed\n');
//           let wasmBytes = null;
//           let capturedOutput = '';
//           try {
//             wasmBytes = compiler.getWebAssemblyOutputFile("app.wasm");
//             if (wasmBytes && wasmBytes.length > 0) {
//               addToConsole(`WebAssembly module: ${wasmBytes.length} bytes\n`);
              
//               const { load } = await import('./c.js');
//               const runtime = await load(wasmBytes);
              
//               addToConsole('WebAssembly module loaded successfully\n');
              
//               const originalLog = console.log;
//               console.log = function(...args) {
//                 capturedOutput += args.join(' ') + '\n';
//                 originalLog.apply(console, args);
//               };
              
//               if (runtime.exports && runtime.exports.main) {
//                 runtime.exports.main([]);
//                 addToConsole('Executed WebAssembly main method\n');
//               } else {
//                 addToConsole('No main method found in WebAssembly exports\n');
//                 addToConsole('Available exports: ' + Object.keys(runtime.exports).join(', ') + '\n');
//               }
              
//               console.log = originalLog;
              
//             } else {
//               addToConsole('No WebAssembly output found\n');
//             }
//           } catch (wasmError) {
//             addToConsole(`WebAssembly execution failed: ${wasmError.message}\n`);
//           }
          
//           if (capturedOutput && capturedOutput.trim() !== '') {
//             setJsOutput(capturedOutput);
//             setCanRun(true);
//             setStatus('Compilation successful!');
//           } else {
//             setJsOutput(`// Compilation successful
// // WebAssembly module generated and executed
// // Check the Console Output section below for results`);
//             setStatus('Compilation successful');
//           }
          
//         } catch (generateError) {
//           setJsOutput('// Generation failed: ' + generateError.message);
//           setStatus('Generation failed');
//           addToConsole('Generation failed: ' + generateError.message + '\n');
//         }
        
//       } else {
//         setJsOutput('// Java compilation failed');
//         setStatus('Java compilation failed');
//         addToConsole('Java compilation failed\n');
        
//         if (diagnostics.length > 0) {
//           addToConsole('\nDiagnostics:\n');
//           diagnostics.forEach(d => {
//             addToConsole(`${d.severity}: ${d.message}\n`);
//           });
//         }
//       }
      
//       if (listener && listener.destroy) {
//         listener.destroy();
//       }
      
//     } catch (error) {
//       setJsOutput('// Error: ' + error.message);
//       setStatus('Compilation error: ' + error.message);
//       addToConsole('Compilation error: ' + error.message + '\n');
//       addToConsole('Stack trace: ' + error.stack + '\n');
//       console.error('Compilation error:', error);
//     }
//   };

//   const clearAll = () => {
//     setJavaCode(`public class Main {
//     public static void main(String[] args) {
//         System.out.println("Hello from Codii!");
//     }
// }`);
//     setJsOutput('');
//     setConsoleOutput('');
//     setCanRun(false);
//     setStatus(isInitialized ? 'Ready to compile!' : 'Loading...');
//   };

//   return (
//     <div className="app-container">
//       {/* Top Bar */}
//       <div className="top-bar">
//         <div className="left-section">
//           <img src="/codii_logo_trans.png" alt="Codii Logo" className="codii-logo"/>
//         </div>
        
//         <div className="center-section">
//           <button className="icon-btn share-btn" title="Share">
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
//               <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
//             </svg>
//             Share
//           </button>
          
//           <button
//             onClick={compileJava}
//             disabled={!isInitialized}
//             className={`run-btn ${!isInitialized ? 'disabled' : ''}`}
//           >
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
//               <path d="M3 2v12l10-6L3 2z"/>
//             </svg>
//             Run
//           </button>
//         </div>
        
//         <div className="right-section">
//           <span className="output-label">Output</span>
//           <button onClick={clearAll} className="clear-btn">Clear</button>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="main-content">
//         {/* Left Section - Java Code */}
//         <div className="editor-section">
//           <Editor
//             height="100%"
//             language="java"
//             theme="vs-dark"
//             value={javaCode}
//             onChange={(value) => setJavaCode(value || '')}
//             options={editorOptions}
//           />
//         </div>

//         {/* Right Section - Output */}
//         <div className="editor-section output-section">
//           <Editor
//             height="100%"
//             language="javascript"
//             theme="vs-dark"
//             value={jsOutput}
//             options={{ ...editorOptions, readOnly: true }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default JavaCompiler;



// import React, { useEffect, useRef, useState } from "react";
// import Editor from "@monaco-editor/react";
// import "../App.css";

// export default function JavaCompiler() {
//   // --- kept original states & refs ---
//   const [javaCode, setJavaCode] = useState(`public class Main {
//     public static void main(String[] args) {
//         System.out.println("Hello from Codii!");
//         int result = fibonacci(10);
//         System.out.println("Fibonacci(10) = " + result);
//     }
    
//     public static int fibonacci(int n) {
//         if (n <= 1) return n;
//         return fibonacci(n - 1) + fibonacci(n - 2);
//     }
// }`);
//   const [jsOutput, setJsOutput] = useState("");
//   const [consoleOutput, setConsoleOutput] = useState("");
//   const [status, setStatus] = useState("Loading...");
//   const [isInitialized, setIsInitialized] = useState(false);
//   const [canRun, setCanRun] = useState(false);
//   const compilerRef = useRef(null);

//   // --- UI states (to match JS UI layout) ---
//   const [userInput, setUserInput] = useState("");
//   const [expectedOutput, setExpectedOutput] = useState("");
//   const [programOutput, setProgramOutput] = useState("");
//   const [verdict, setVerdict] = useState(null); // { ok: boolean, message: string }

//   const iframeRef = useRef(null);
//   const terminalRef = useRef(null);

//   const editorOptions = {
//     minimap: { enabled: false },
//     automaticLayout: true,
//     fontFamily: "JetBrains Mono, Fira Code, monospace",
//     fontSize: 13,
//     lineHeight: 20,
//     padding: { top: 12, bottom: 12 },
//   };

//   const addToConsole = (text) => {
//     setConsoleOutput((prev) => prev + text);
//     // auto-scroll
//     setTimeout(() => {
//       if (terminalRef.current) terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
//     }, 0);
//   };

//   // --- initialization (kept original) ---
//   useEffect(() => {
//     const initializeTeaVM = async () => {
//       setStatus("Loading...");
//       addToConsole("Setting Up Connection...\n");

//       try {
//         addToConsole("Loading WebAssembly module...\n");
//         const { load } = await import('./c.js');
//         const teavm = await load('/compiler.wasm');
//         const compilerLib = teavm.exports;
//         addToConsole("WebAssembly module loaded successfully\n");

//         addToConsole("Creating compiler instance...\n");
//         compilerRef.current = compilerLib.createCompiler();
//         addToConsole("Compiler instance created\n");

//         setStatus("Loading SDK...");
//         addToConsole("Loading SDK from compile-classlib-teavm.bin...\n");
//         let response = await fetch('/compile-classlib-teavm.bin');
//         if (!response.ok) throw new Error(`Failed to load SDK: ${response.status} ${response.statusText}`);
//         let arrayBuffer = await response.arrayBuffer();
//         addToConsole(`SDK loaded: ${arrayBuffer.byteLength} bytes\n`);
//         compilerRef.current.setSdk(new Uint8Array(arrayBuffer));
//         addToConsole("SDK set successfully\n");

//         setStatus("Loading runtime...");
//         addToConsole("Loading runtime from runtime-classlib-teavm.bin...\n");
//         response = await fetch('/runtime-classlib-teavm.bin');
//         if (!response.ok) throw new Error(`Failed to load runtime: ${response.status} ${response.statusText}`);
//         arrayBuffer = await response.arrayBuffer();
//         addToConsole(`Runtime loaded: ${arrayBuffer.byteLength} bytes\n`);
//         compilerRef.current.setTeaVMClasslib(new Uint8Array(arrayBuffer));
//         addToConsole("Runtime set successfully\n");

//         setStatus("Ready to compile!");
//         addToConsole("Initialization complete! Ready to compile Java code.\n");
//         setIsInitialized(true);
//       } catch (error) {
//         setStatus("Error: " + error.message);
//         addToConsole("Initialization error: " + error.message + "\n");
//         addToConsole("Stack trace: " + (error.stack || "") + "\n");
//         console.error("Initialization error:", error);
//       }
//     };

//     initializeTeaVM();
//   }, []);

//   // --- normalization & compare helpers (robust) ---
//   const normalize = (s) =>
//     (s ?? "")
//       .replace(/\r/g, "")
//       .split("\n")
//       .map(line => line.replace(/[ \t]+$/g, ""))
//       .join("\n")
//       .replace(/\n+$/g, "")
//       .trim();

//   const compareOutputs = (actual, expected) => {
//     const a = normalize(actual);
//     const e = normalize(expected);
//     return { ok: a === e, actual: a, expected: e };
//   };

//   // --- compile & run (kept your original logic, adapted to set programOutput & verdict) ---
//   const compileJava = async () => {
//     if (!isInitialized) {
//       alert("Connection not ready yet. Please wait for initialization.");
//       return;
//     }

//     const compiler = compilerRef.current;
//     setStatus("Compiling...");
//     setConsoleOutput("Starting compilation...\n");

//     // reset
//     setProgramOutput("");
//     setJsOutput("");
//     setVerdict(null);

//     try {
//       const diagnostics = [];
//       const listener = compiler.onDiagnostic
//         ? compiler.onDiagnostic((diagnostic) => {
//             diagnostics.push(diagnostic);
//             addToConsole(`[${diagnostic.severity}] ${diagnostic.fileName}:${diagnostic.lineNumber} - ${diagnostic.message}\n`);
//           })
//         : null;

//       compiler.clearSourceFiles();
//       compiler.addSourceFile("Main.java", javaCode);

//       addToConsole("Source file added, compiling Java...\n");

//       const compileResult = compiler.compile();
//       addToConsole(`Java compilation result: ${compileResult}\n`);

//       if (compileResult) {
//         addToConsole("Generating WebAssembly and trying to execute...\n");

//         try {
//           compiler.generateWebAssembly({
//             outputName: "app",
//             mainClass: "Main",
//           });
//           addToConsole("WebAssembly generation completed\n");

//           let wasmBytes = null;
//           let capturedOutput = "";
//           try {
//             wasmBytes = compiler.getWebAssemblyOutputFile("app.wasm");
//             if (wasmBytes && wasmBytes.length > 0) {
//               addToConsole(`WebAssembly module: ${wasmBytes.length} bytes\n`);

//               const { load } = await import('./c.js');
//               const runtime = await load(wasmBytes);

//               addToConsole("WebAssembly module loaded successfully\n");

//               const originalLog = console.log;
//               console.log = function (...args) {
//                 capturedOutput += args.join(" ") + "\n";
//                 originalLog.apply(console, args);
//               };

//               // TODO: If your runtime supports feeding stdin, inject `userInput` here.
//               // Example placeholder:
//               // if (runtime.exports && runtime.exports.setStdinBuffer) {
//               //   runtime.exports.setStdinBuffer(userInput || "");
//               // }

//               if (runtime.exports && runtime.exports.main) {
//                 try {
//                   runtime.exports.main([]);
//                   addToConsole("Executed WebAssembly main method\n");
//                 } catch (runErr) {
//                   addToConsole("Runtime execution threw: " + (runErr && runErr.message ? runErr.message : String(runErr)) + "\n");
//                 }
//               } else {
//                 addToConsole("No main method found in WebAssembly exports\n");
//                 addToConsole("Available exports: " + Object.keys(runtime.exports || {}).join(", ") + "\n");
//               }

//               console.log = originalLog;
//             } else {
//               addToConsole("No WebAssembly output found\n");
//             }
//           } catch (wasmError) {
//             addToConsole(`WebAssembly execution failed: ${wasmError.message}\n`);
//           }

//           setProgramOutput(capturedOutput);
//           setJsOutput(capturedOutput || `// Compilation successful\n// WebAssembly module generated; check Console Output for details.`);

//           // compare if expected provided
//           if (expectedOutput && expectedOutput.trim().length > 0) {
//             const cmp = compareOutputs(capturedOutput, expectedOutput);
//             setVerdict(cmp.ok ? { ok: true, message: "Passed" } : { ok: false, message: "Failed" });
//             if (!cmp.ok) {
//               addToConsole("\n--- Expected (normalized) ---\n" + (cmp.expected || "(empty)") + "\n");
//               addToConsole("--- Actual (normalized) ---\n" + (cmp.actual || "(empty)") + "\n");
//             } else {
//               addToConsole("Output matches expected output (PASSED)\n");
//             }
//           }

//           setStatus("Compilation successful!");
//           setCanRun(true);
//         } catch (generateError) {
//           setJsOutput("// Generation failed: " + generateError.message);
//           setStatus("Generation failed");
//           addToConsole("Generation failed: " + generateError.message + "\n");
//         }
//       } else {
//         setJsOutput("// Java compilation failed");
//         setStatus("Java compilation failed");
//         addToConsole("Java compilation failed\n");

//         if (diagnostics.length > 0) {
//           addToConsole("\nDiagnostics:\n");
//           diagnostics.forEach((d) => addToConsole(`${d.severity}: ${d.message}\n`));
//         }
//       }

//       if (listener && listener.destroy) listener.destroy();
//     } catch (error) {
//       setJsOutput("// Error: " + error.message);
//       setStatus("Compilation error: " + error.message);
//       addToConsole("Compilation error: " + error.message + "\n");
//       addToConsole("Stack trace: " + (error.stack || "") + "\n");
//       console.error("Compilation error:", error);
//     }
//   };

//   // --- helpers to clear inputs ---
//   const clearInput = () => setUserInput("");
//   const clearExpected = () => setExpectedOutput("");
//   const clearAll = () => {
//     setJavaCode(`public class Main {
//     public static void main(String[] args) {
//         System.out.println("Hello from Codii!");
//     }
// }`);
//     setJsOutput("");
//     setConsoleOutput("");
//     setCanRun(false);
//     setStatus(isInitialized ? "Ready to compile!" : "Loading...");
//     setUserInput("");
//     setExpectedOutput("");
//     setProgramOutput("");
//     setVerdict(null);

//     const f = document.getElementById("preview-frame");
//     if (f) f.srcdoc = "";
//   };

//   // --- mirror programOutput into preview iframe (UI only) ---
//   useEffect(() => {
//     const previewFrame = document.getElementById("preview-frame");
//     if (previewFrame) {
//       const safe = `<meta charset="utf-8"><style>body{background:#0f0f0f;color:#dcdcdc;font-family:monospace;padding:12px;white-space:pre-wrap}</style><pre>${(programOutput || "")
//         .replace(/&/g, "&amp;")
//         .replace(/</g, "&lt;")
//         .replace(/>/g, "&gt;")}</pre>`;
//       if (previewFrame.srcdoc !== safe) previewFrame.srcdoc = safe;
//     }
//   }, [programOutput]);

//   // --- Render same DOM structure + IDs/classes as your JS UI ---
//   return (
//     <div id="app-root" style={{ height: "100vh" }}>
//       <div id="main">
//         <div id="topbar">
//           <div id="title">
//             <img id="logo" src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png" alt="logo" />
//           </div>
//           <div id="actions">
//             <button id="compile" onClick={compileJava} disabled={!isInitialized} className={!isInitialized ? "disabled" : ""}>
//               Compile
//             </button>
//           </div>
//         </div>

//         <div id="main-grid">
//           <div id="col-editor" className="col">
//             <div className="panel-header">Editor</div>
//             <div id="editor" className="panel-body" style={{ minHeight: 0 }}>
//               <Editor
//                 height="100%"
//                 language="java"
//                 theme="vs-dark"
//                 value={javaCode}
//                 onChange={(v) => setJavaCode(v || "")}
//                 options={editorOptions}
//               />
//             </div>
//           </div>

//           <div id="col-center" className="col">
//             <div id="center-top" className="half">
//               <div className="panel-header">
//                 Program Input <small>(optional)</small>
//                 <div className="header-controls">
//                   <button id="clear-input" title="Clear input" onClick={clearInput}>Clear</button>
//                 </div>
//               </div>
//               <textarea id="stdin-input" className="panel-body textarea" value={userInput} onChange={(e) => setUserInput(e.target.value)} />
//             </div>

//             <div id="center-bottom" className="half">
//               <div className="panel-header">
//                 Preview
//                 <div className="header-controls">
//                   <div id="validation-status" style={{ display: verdict ? "flex" : "none" }}>
//                     <div id="validation-result" className={`validation-result ${verdict && verdict.ok ? "passed" : "failed"}`}>
//                       {verdict ? (verdict.ok ? "✓ PASSED" : "✗ FAILED") : ""}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div id="preview-area" className="panel-body" style={{ padding: 0 }}>
//                 <iframe id="preview-frame" title="preview" style={{ width: "100%", height: "100%", border: 0 }} />
//               </div>
//             </div>
//           </div>

//           <div id="col-expected" className="col">
//             <div id="expected-top" className="half">
//               <div className="panel-header">
//                 Expected Output
//                 <div className="header-controls">
//                   <button id="clear-expected" title="Clear expected output" onClick={clearExpected}>Clear</button>
//                 </div>
//               </div>
//               <textarea id="expected-output" className="panel-body textarea" value={expectedOutput} onChange={(e) => setExpectedOutput(e.target.value)} />
//             </div>

//             <div id="expected-bottom" className="half">
//               <div className="panel-header">Console Output / Diagnostics</div>
//               <div id="terminal-attach" className="panel-body terminal-attach" style={{ padding: 0 }}>
//                 <textarea
//                   ref={terminalRef}
//                   readOnly
//                   value={consoleOutput}
//                   style={{
//                     width: "100%",
//                     height: "100%",
//                     resize: "none",
//                     background: "#070707",
//                     color: "#e6e6e6",
//                     border: "none",
//                     padding: 8,
//                     fontFamily: "JetBrains Mono, monospace",
//                     fontSize: 13,
//                     outline: "none",
//                     whiteSpace: "pre"
//                   }}
//                 />
//               </div>

//               <div
//                 id="status"
//                 className="status"
//                 style={verdict ? { color: verdict.ok ? "#00ff88" : "#ff5744" } : {}}
//               >
//                 {verdict ? verdict.message : status}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }




// Full working code with Java input/output handling

// import React, { useEffect, useRef, useState } from "react";
// import Editor from "@monaco-editor/react";
// import "../App.css";

// /*
//   JavaCompiler.jsx - C++ style input/output handling
//   - Injects input into compiled WASM HTML
//   - Captures output via postMessage from iframe
//   - Validates output against expected
// */

// // Scanner shim
// const SCANNER_SHIM = `import java.io.InputStream;
// import java.io.IOException;

// public class Scanner {
//     private String input = "";
//     private String[] tokens = null;
//     private int idx = 0;

//     public Scanner(InputStream in) { 
//         readAll(in); 
//     }
    
//     public Scanner() {
//         this.input = StdinProvider.getInput();
//         prepareTokens();
//     }

//     private void readAll(InputStream in) {
//         if (in == null) {
//             this.input = StdinProvider.getInput();
//             prepareTokens();
//             return;
//         }
        
//         StringBuilder buf = new StringBuilder();
//         try {
//             int c;
//             while ((c = in.read()) != -1) {
//                 buf.append((char) c);
//             }
//             this.input = buf.toString();
//         } catch (IOException e) { 
//             this.input = StdinProvider.getInput();
//         }
//         prepareTokens();
//     }

//     private void prepareTokens() {
//         if (input == null || input.length() == 0) {
//             tokens = new String[0];
//         } else {
//             tokens = input.trim().split("\\\\s+");
//         }
//         idx = 0;
//     }

//     public boolean hasNext() { 
//         return tokens != null && idx < tokens.length; 
//     }
    
//     public String next() {
//         if (!hasNext()) {
//             throw new RuntimeException("No more tokens available");
//         }
//         return tokens[idx++];
//     }
    
//     public int nextInt() { 
//         return Integer.parseInt(next()); 
//     }
    
//     public long nextLong() { 
//         return Long.parseLong(next()); 
//     }
    
//     public double nextDouble() { 
//         return Double.parseDouble(next()); 
//     }
    
//     public String nextLine() {
//         if (idx < tokens.length) {
//             StringBuilder line = new StringBuilder();
//             while (idx < tokens.length) {
//                 if (line.length() > 0) line.append(" ");
//                 line.append(tokens[idx++]);
//             }
//             return line.toString();
//         }
//         return "";
//     }
    
//     public void close() { }
// }

// class StdinProvider {
//     private static String inputData = "";
    
//     public static void setInput(String data) {
//         inputData = data;
//     }
    
//     public static String getInput() {
//         return inputData;
//     }
// }
// `;

// export default function JavaCompiler() {
//   const [javaCode, setJavaCode] = useState(`import java.util.Scanner;
// public class Main {
//     public static void main(String[] args) {
//         Scanner sc = new Scanner(System.in);
//         int t = sc.nextInt();
//         while (t-- > 0) {
//             int n = sc.nextInt();
//             System.out.println(n * 2);
//         }
//         sc.close();
//     }
// }`);
//   const [terminalOutput, setTerminalOutput] = useState("");
//   const [status, setStatus] = useState("Loading...");
//   const [isInitialized, setIsInitialized] = useState(false);
//   const compilerRef = useRef(null);

//   const [userInput, setUserInput] = useState("3\n1\n4\n10");
//   const [expectedOutput, setExpectedOutput] = useState("2\n8\n20");
//   const [verdict, setVerdict] = useState(null);
//   const [showLoader, setShowLoader] = useState(true);

//   const terminalRef = useRef(null);
//   const receivedOutputsRef = useRef([]);
//   const outputCheckTimeoutRef = useRef(null);

//   const editorOptions = {
//     minimap: { enabled: false },
//     automaticLayout: true,
//     fontFamily: "JetBrains Mono, Fira Code, monospace",
//     fontSize: 13,
//     lineHeight: 20,
//     padding: { top: 12, bottom: 12 },
//   };

//   const addToTerminal = (text) => {
//     setTerminalOutput((prev) => {
//       const next = prev + text;
//       setTimeout(() => {
//         if (terminalRef.current) terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
//       }, 0);
//       return next;
//     });
//   };

//   const normalize = (s) =>
//     (s ?? "")
//       .replace(/\r/g, "")
//       .split("\n")
//       .map(line => line.replace(/[ \t]+$/g, ""))
//       .join("\n")
//       .replace(/\n+$/g, "")
//       .trim();

//   const compareOutputs = (actual, expected) => {
//     const a = normalize(actual);
//     const e = normalize(expected);
//     return { ok: a === e, actual: a, expected: e };
//   };

//   useEffect(() => {
//     const initializeTeaVM = async () => {
//       setStatus("Loading...");
//       addToTerminal("Setting Up Connection...\n");

//       try {
//         addToTerminal("Loading WebAssembly module...\n");
//         const { load } = await import('./c.js');
//         const teavm = await load('/compiler.wasm');
//         const compilerLib = teavm.exports;
//         addToTerminal("WebAssembly module loaded successfully\n");

//         addToTerminal("Creating compiler instance...\n");
//         compilerRef.current = compilerLib.createCompiler();
//         addToTerminal("Compiler instance created\n");

//         setStatus("Loading SDK...");
//         addToTerminal("Loading SDK from compile-classlib-teavm.bin...\n");
//         let response = await fetch('/compile-classlib-teavm.bin');
//         if (!response.ok) throw new Error(`Failed to load SDK: ${response.status} ${response.statusText}`);
//         let arrayBuffer = await response.arrayBuffer();
//         addToTerminal(`SDK loaded: ${arrayBuffer.byteLength} bytes\n`);
//         compilerRef.current.setSdk(new Uint8Array(arrayBuffer));
//         addToTerminal("SDK set successfully\n");

//         setStatus("Loading runtime...");
//         addToTerminal("Loading runtime from runtime-classlib-teavm.bin...\n");
//         response = await fetch('/runtime-classlib-teavm.bin');
//         if (!response.ok) throw new Error(`Failed to load runtime: ${response.status} ${response.statusText}`);
//         arrayBuffer = await response.arrayBuffer();
//         addToTerminal(`Runtime loaded: ${arrayBuffer.byteLength} bytes\n`);
//         compilerRef.current.setTeaVMClasslib(new Uint8Array(arrayBuffer));
//         addToTerminal("Runtime set successfully\n");

//         setStatus("Ready to compile!");
//         addToTerminal("Initialization complete! Ready to compile Java code.\n");
//         setIsInitialized(true);
//         setShowLoader(false);
//       } catch (error) {
//         setStatus("Error: " + error.message);
//         addToTerminal("Initialization error: " + error.message + "\n");
//         addToTerminal("Stack trace: " + (error.stack || "") + "\n");
//         console.error("Initialization error:", error);
//         setShowLoader(false);
//       }
//     };

//     initializeTeaVM();
//   }, []);

//   // Listen for output messages from preview iframe
//   useEffect(() => {
//     const handleMessage = (event) => {
//       if (event.data && event.data.type === 'programOutput') {
//         const newOutput = event.data.output || "";
//         console.log('Received output from iframe:', newOutput.length, 'chars');
//         receivedOutputsRef.current.push(newOutput);

//         if (outputCheckTimeoutRef.current) clearTimeout(outputCheckTimeoutRef.current);
        
//         outputCheckTimeoutRef.current = setTimeout(() => {
//           // Pick the longest output received (most complete)
//           const actualOutput = receivedOutputsRef.current.reduce(
//             (longest, cur) => cur.length > longest.length ? cur : longest, 
//             ''
//           );
          
//           const expected = expectedOutput || "";
//           if (expected.trim()) {
//             const cmp = compareOutputs(actualOutput, expected);
//             setVerdict(cmp.ok ? { ok: true, message: "Passed" } : { ok: false, message: "Failed" });
            
//             addToTerminal("\n=== Output Validation ===\n");
//             if (cmp.ok) {
//               addToTerminal("✓ Output matches expected output (PASSED)\n");
//             } else {
//               addToTerminal("✗ Output does not match expected output (FAILED)\n");
//               addToTerminal("\n--- Expected (normalized) ---\n'" + cmp.expected + "'\n");
//               addToTerminal("\n--- Actual (normalized) ---\n'" + cmp.actual + "'\n");
//               if (actualOutput.trim() === '') {
//                 addToTerminal("\n⚠️  WARNING: Actual output is empty!\n");
//               }
//             }
//             addToTerminal("========================\n\n");
//           }
          
//           receivedOutputsRef.current = [];
//         }, 1200);
//       }
//     };

//     window.addEventListener('message', handleMessage);
//     return () => window.removeEventListener('message', handleMessage);
//   }, [expectedOutput]);

//   const compileJava = async () => {
//     if (!isInitialized) {
//       alert("Connection not ready yet. Please wait for initialization.");
//       return;
//     }

//     const compiler = compilerRef.current;
//     setStatus("Compiling...");
//     setTerminalOutput("Starting compilation...\n");
//     setVerdict(null);
//     receivedOutputsRef.current = [];

//     try {
//       const diagnostics = [];
//       const listener = compiler.onDiagnostic
//         ? compiler.onDiagnostic((diagnostic) => {
//             diagnostics.push(diagnostic);
//             addToTerminal(`[${diagnostic.severity}] ${diagnostic.fileName}:${diagnostic.lineNumber} - ${diagnostic.message}\n`);
//           })
//         : null;

//       // Patch user code
//       let patchedCode = javaCode
//         .replace(/import\s+java\.util\.Scanner\s*;/g, '// Scanner provided')
//         .replace(/import\s+java\.util\.\*\s*;/g, 'import java.util.*;');
      
//       // Inject StdinProvider.setInput call at start of main
//       patchedCode = patchedCode.replace(
//         /(public\s+static\s+void\s+main\s*\([^)]*\)\s*\{)/,
//         `$1
//         StdinProvider.setInput("${(userInput || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r')}");`
//       );

//       compiler.clearSourceFiles();
//       compiler.addSourceFile("Scanner.java", SCANNER_SHIM);
//       compiler.addSourceFile("Main.java", patchedCode);

//       addToTerminal("Source file(s) added (with Scanner shim), compiling Java...\n");

//       const compileResult = compiler.compile();
//       addToTerminal(`Java compilation result: ${compileResult}\n`);

//       if (compileResult) {
//         addToTerminal("Generating WebAssembly...\n");

//         try {
//           compiler.generateWebAssembly({
//             outputName: "app",
//             mainClass: "Main",
//           });
//           addToTerminal("WebAssembly generation completed\n");

//           const wasmBytes = compiler.getWebAssemblyOutputFile("app.wasm");
//           if (wasmBytes && wasmBytes.length > 0) {
//             addToTerminal(`WebAssembly module: ${wasmBytes.length} bytes\n`);

//             // Create Blob URL for WASM (avoids stack overflow on large files)
//             const wasmBlob = new Blob([wasmBytes], { type: 'application/wasm' });
//             const wasmUrl = URL.createObjectURL(wasmBlob);

//             // Create HTML with injected input and output capture (C++ style)
//             const inputJSON = JSON.stringify(userInput || "");
//             const htmlContent = `<!DOCTYPE html>
// <html>
// <head>
//   <meta charset="utf-8">
//   <script>
//     // Store input buffer
//     (function(){
//       window.__JAVA_STDIN_BUFFER = ${inputJSON};
//       console.log('Java: input buffer stored (len=' + (window.__JAVA_STDIN_BUFFER||'').length + ')');
//     })();
//   </script>
//   <script>
//     // Capture console.log output and send to parent
//     (function() {
//       var capturedOutput = '';
//       var originalLog = console.log;
//       var originalError = console.error;
      
//       console.log = function(...args) {
//         var line = args.join(' ');
//         capturedOutput += line + '\\n';
//         originalLog.apply(console, args);
        
//         // Send output to parent
//         if (window.parent !== window) {
//           try {
//             window.parent.postMessage({
//               type: 'programOutput',
//               output: capturedOutput
//             }, '*');
//           } catch(e) {}
//         }
//       };
      
//       console.error = function(...args) {
//         var line = args.join(' ');
//         capturedOutput += line + '\\n';
//         originalError.apply(console, args);
        
//         if (window.parent !== window) {
//           try {
//             window.parent.postMessage({
//               type: 'programOutput',
//               output: capturedOutput
//             }, '*');
//           } catch(e) {}
//         }
//       };
      
//       // Send final output after execution
//       window.addEventListener('load', function() {
//         setTimeout(function() {
//           if (window.parent !== window && capturedOutput) {
//             try {
//               window.parent.postMessage({
//                 type: 'programOutput',
//                 output: capturedOutput
//               }, '*');
//             } catch(e) {}
//           }
//         }, 500);
//       });
//     })();
//   </script>
// </head>
// <body style="background: #0f0f0f; color: #dcdcdc; font-family: monospace; padding: 12px;">
//   <pre id="output"></pre>
//   <script type="module">
//     // Load and run WASM
//     (async function() {
//       try {
//         // Fetch WASM from blob URL
//         const wasmResponse = await fetch('${wasmUrl}');
//         const wasmBytes = new Uint8Array(await wasmResponse.arrayBuffer());
        
//         // Import c.js loader
//         const { load } = await import('./c.js');
//         const runtime = await load(wasmBytes);
        
//         // Run main
//         if (runtime.exports && typeof runtime.exports.main === 'function') {
//           runtime.exports.main([]);
//           console.log('Program execution completed');
//         } else {
//           console.error('No main method found');
//         }
//       } catch(err) {
//         console.error('Execution error:', err.message || String(err));
//       }
//     })();
//   </script>
// </body>
// </html>`;

//             // Set iframe content
//             const previewFrame = document.getElementById("preview-frame");
//             if (previewFrame) {
//               previewFrame.srcdoc = htmlContent;
//               addToTerminal("✓ Preview updated with compiled program\n");
//             }

//             setStatus("Execution finished");
//             addToTerminal("=== Program finished ===\n");
//           } else {
//             addToTerminal("No WebAssembly output found\n");
//           }
//         } catch (generateError) {
//           setStatus("Generation failed");
//           addToTerminal("Generation failed: " + (generateError && generateError.message ? generateError.message : String(generateError)) + "\n");
//         }
//       } else {
//         setStatus("Java compilation failed");
//         addToTerminal("Java compilation failed\n");

//         if (diagnostics.length > 0) {
//           addToTerminal("\nDiagnostics:\n");
//           diagnostics.forEach((d) => addToTerminal(`${d.severity}: ${d.message}\n`));
//         }
//       }

//       if (listener && listener.destroy) listener.destroy();
//     } catch (error) {
//       setStatus("Compilation error: " + (error && error.message ? error.message : String(error)));
//       addToTerminal("Compilation error: " + (error && error.message ? error.message : String(error)) + "\n");
//       addToTerminal("Stack trace: " + (error && error.stack ? error.stack : "") + "\n");
//       console.error("Compilation error:", error);
//     }
//   };

//   const clearInput = () => setUserInput("");
//   const clearExpected = () => {
//     setExpectedOutput("");
//     setVerdict(null);
//   };

//   if (showLoader) {
//     return (
//       <div className="codii-loader-container">
//         <img src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png" alt="Codii Logo" className="codii-loader-logo" />
//         <div className="codii-progress-bar"><div className="codii-progress-fill" /></div>
//         <div className="codii-loader-text">Initializing your coding space...</div>
//       </div>
//     );
//   }

//   return (
//     <div id="app-root" style={{ height: "100vh" }}>
//       <div id="main">
//         <div id="topbar">
//           <div id="title">
//             <img id="logo" src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png" alt="logo" />
//           </div>
//           <div id="actions">
//             <button id="compile" onClick={compileJava} disabled={!isInitialized}>Compile</button>
//           </div>
//         </div>

//         <div id="main-grid">
//           <div id="col-editor" className="col">
//             <div className="panel-header">Editor</div>
//             <div id="editor" className="panel-body" style={{ minHeight: 0 }}>
//               <Editor
//                 height="100%"
//                 language="java"
//                 theme="vs-dark"
//                 value={javaCode}
//                 onChange={(v) => setJavaCode(v || "")}
//                 options={editorOptions}
//               />
//             </div>
//           </div>

//           <div id="col-center" className="col">
//             <div id="center-top" className="half">
//               <div className="panel-header">
//                 Program Input <small>(optional)</small>
//                 <div className="header-controls">
//                   <button id="clear-input" title="Clear input" onClick={clearInput}>Clear</button>
//                 </div>
//               </div>
//               <textarea id="stdin-input" className="panel-body textarea" value={userInput} onChange={(e) => setUserInput(e.target.value)} />
//             </div>

//             <div id="center-bottom" className="half">
//               <div className="panel-header">
//                 Preview
//                 <div className="header-controls">
//                   <div id="validation-status" style={{ display: 'none' }}>
//                     <div id="validation-result" className="validation-result"></div>
//                   </div>
//                 </div>
//               </div>
//               <div id="preview-area" className="panel-body" style={{ padding: 0 }}>
//                 <iframe id="preview-frame" title="preview" style={{ width: "100%", height: "100%", border: 0 }} />
//               </div>
//             </div>
//           </div>

//           <div id="col-expected" className="col">
//             <div id="expected-top" className="half">
//               <div className="panel-header">
//                 Expected Output
//                 <div className="header-controls">
//                   <button id="clear-expected" title="Clear expected output" onClick={clearExpected}>Clear</button>
//                 </div>
//               </div>
//               <textarea id="expected-output" className="panel-body textarea" value={expectedOutput} onChange={(e) => setExpectedOutput(e.target.value)} />
//             </div>

//             <div id="expected-bottom" className="half">
//               <div className="panel-header">Terminal Output</div>
//               <div id="terminal-attach" className="panel-body terminal-attach" style={{ padding: 0 }}>
//                 <textarea
//                   ref={terminalRef}
//                   readOnly
//                   value={terminalOutput}
//                   style={{
//                     width: "100%",
//                     height: "100%",
//                     resize: "none",
//                     background: "#070707",
//                     color: "#e6e6e6",
//                     border: "none",
//                     padding: 8,
//                     fontFamily: "JetBrains Mono, monospace",
//                     fontSize: 13,
//                     outline: "none",
//                     whiteSpace: "pre"
//                   }}
//                 />
//               </div>
//               <div
//                 id="status"
//                 className="status"
//                 style={verdict ? { background: verdict.ok ? "green" : "red" } : {}}
//               >
//                 {verdict ? verdict.message : status}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Editor from "@monaco-editor/react";
import { fileAPI } from '../services/api';
import "../App.css";

/*
  JavaCompiler.jsx - C++ style input/output handling
  - Injects input into compiled WASM HTML
  - Captures output via postMessage from iframe
  - Validates output against expected
*/

// Scanner shim
const SCANNER_SHIM = `import java.io.InputStream;
import java.io.IOException;

public class Scanner {
    private String input = "";
    private String[] tokens = null;
    private int idx = 0;

    public Scanner(InputStream in) { 
        readAll(in); 
    }
    
    public Scanner() {
        this.input = StdinProvider.getInput();
        prepareTokens();
    }

    private void readAll(InputStream in) {
        if (in == null) {
            this.input = StdinProvider.getInput();
            prepareTokens();
            return;
        }
        
        StringBuilder buf = new StringBuilder();
        try {
            int c;
            while ((c = in.read()) != -1) {
                buf.append((char) c);
            }
            this.input = buf.toString();
        } catch (IOException e) { 
            this.input = StdinProvider.getInput();
        }
        prepareTokens();
    }

    private void prepareTokens() {
        if (input == null || input.length() == 0) {
            tokens = new String[0];
        } else {
            tokens = input.trim().split("\\\\s+");
        }
        idx = 0;
    }

    public boolean hasNext() { 
        return tokens != null && idx < tokens.length; 
    }
    
    public String next() {
        if (!hasNext()) {
            throw new RuntimeException("No more tokens available");
        }
        return tokens[idx++];
    }
    
    public int nextInt() { 
        return Integer.parseInt(next()); 
    }
    
    public long nextLong() { 
        return Long.parseLong(next()); 
    }
    
    public double nextDouble() { 
        return Double.parseDouble(next()); 
    }
    
    public String nextLine() {
        if (idx < tokens.length) {
            StringBuilder line = new StringBuilder();
            while (idx < tokens.length) {
                if (line.length() > 0) line.append(" ");
                line.append(tokens[idx++]);
            }
            return line.toString();
        }
        return "";
    }
    
    public void close() { }
}

class StdinProvider {
    private static String inputData = "";
    
    public static void setInput(String data) {
        inputData = data;
    }
    
    public static String getInput() {
        return inputData;
    }
}
`;

export default function JavaCompiler() {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentFile, setCurrentFile] = useState(location.state?.file || null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [javaCode, setJavaCode] = useState(`import java.util.Scanner;
public class Main {
    public static void main(String[] args) {
        Scanner sc = new Scanner(System.in);
        int t = sc.nextInt();
        while (t-- > 0) {
            int n = sc.nextInt();
            System.out.println(n * 2);
        }
        sc.close();
    }
}`);
  const [terminalOutput, setTerminalOutput] = useState("");
  const [status, setStatus] = useState("Loading...");
  const [isInitialized, setIsInitialized] = useState(false);
  const compilerRef = useRef(null);

  const [userInput, setUserInput] = useState("3\n1\n4\n10");
  const [expectedOutput, setExpectedOutput] = useState("2\n8\n20");
  const [verdict, setVerdict] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  const terminalRef = useRef(null);
  const receivedOutputsRef = useRef([]);
  const outputCheckTimeoutRef = useRef(null);

  const editorOptions = {
    minimap: { enabled: false },
    automaticLayout: true,
    fontFamily: "JetBrains Mono, Fira Code, monospace",
    fontSize: 13,
    lineHeight: 20,
    padding: { top: 12, bottom: 12 },
  };

  const addToTerminal = (text) => {
    setTerminalOutput((prev) => {
      const next = prev + text;
      setTimeout(() => {
        if (terminalRef.current) terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
      }, 0);
      return next;
    });
  };

  const normalize = (s) =>
    (s ?? "")
      .replace(/\r/g, "")
      .split("\n")
      .map(line => line.replace(/[ \t]+$/g, ""))
      .join("\n")
      .replace(/\n+$/g, "")
      .trim();

  const compareOutputs = (actual, expected) => {
    const a = normalize(actual);
    const e = normalize(expected);
    return { ok: a === e, actual: a, expected: e };
  };

  // Load file content if opening a file
  useEffect(() => {
    const loadFileContent = async () => {
      if (currentFile && currentFile.id) {
        try {
          const fileData = await fileAPI.getFile(currentFile.id);
          setJavaCode(fileData.content || '');
          setCurrentFile(fileData);
          setHasUnsavedChanges(false);
        } catch (error) {
          console.error('Error loading file:', error);
        }
      }
    };
    loadFileContent();
  }, [currentFile?.id]);

  useEffect(() => {
    const initializeTeaVM = async () => {
      setStatus("Loading...");
      addToTerminal("Setting Up Connection...\n");

      try {
        addToTerminal("Loading WebAssembly module...\n");
        const { load } = await import('./c.js');
        const teavm = await load('/compiler.wasm');
        const compilerLib = teavm.exports;
        addToTerminal("WebAssembly module loaded successfully\n");

        addToTerminal("Creating compiler instance...\n");
        compilerRef.current = compilerLib.createCompiler();
        addToTerminal("Compiler instance created\n");

        setStatus("Loading SDK...");
        addToTerminal("Loading SDK from compile-classlib-teavm.bin...\n");
        let response = await fetch('/compile-classlib-teavm.bin');
        if (!response.ok) throw new Error(`Failed to load SDK: ${response.status} ${response.statusText}`);
        let arrayBuffer = await response.arrayBuffer();
        addToTerminal(`SDK loaded: ${arrayBuffer.byteLength} bytes\n`);
        compilerRef.current.setSdk(new Uint8Array(arrayBuffer));
        addToTerminal("SDK set successfully\n");

        setStatus("Loading runtime...");
        addToTerminal("Loading runtime from runtime-classlib-teavm.bin...\n");
        response = await fetch('/runtime-classlib-teavm.bin');
        if (!response.ok) throw new Error(`Failed to load runtime: ${response.status} ${response.statusText}`);
        arrayBuffer = await response.arrayBuffer();
        addToTerminal(`Runtime loaded: ${arrayBuffer.byteLength} bytes\n`);
        compilerRef.current.setTeaVMClasslib(new Uint8Array(arrayBuffer));
        addToTerminal("Runtime set successfully\n");

        setStatus("Ready to compile!");
        addToTerminal("Initialization complete! Ready to compile Java code.\n");
        setIsInitialized(true);
        setShowLoader(false);
      } catch (error) {
        setStatus("Error: " + error.message);
        addToTerminal("Initialization error: " + error.message + "\n");
        addToTerminal("Stack trace: " + (error.stack || "") + "\n");
        console.error("Initialization error:", error);
        setShowLoader(false);
      }
    };

    initializeTeaVM();
  }, []);

  const compileJava = async () => {
    if (!isInitialized) {
      alert("Connection not ready yet. Please wait for initialization.");
      return;
    }

    const compiler = compilerRef.current;
    setStatus("Compiling...");
    setTerminalOutput("Starting compilation...\n");
    setVerdict(null);
    receivedOutputsRef.current = [];

    try {
      const diagnostics = [];
      const listener = compiler.onDiagnostic
        ? compiler.onDiagnostic((diagnostic) => {
            diagnostics.push(diagnostic);
            addToTerminal(`[${diagnostic.severity}] ${diagnostic.fileName}:${diagnostic.lineNumber} - ${diagnostic.message}\n`);
          })
        : null;

      // Patch user code
      let patchedCode = javaCode
        .replace(/import\s+java\.util\.Scanner\s*;/g, '// Scanner provided')
        .replace(/import\s+java\.util\.\*\s*;/g, 'import java.util.*;');
      
      // Inject StdinProvider.setInput call at start of main
      patchedCode = patchedCode.replace(
        /(public\s+static\s+void\s+main\s*\([^)]*\)\s*\{)/,
        `$1
        StdinProvider.setInput("${(userInput || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r')}");`
      );

      compiler.clearSourceFiles();
      compiler.addSourceFile("Scanner.java", SCANNER_SHIM);
      compiler.addSourceFile("Main.java", patchedCode);

      addToTerminal("Source file(s) added (with Scanner shim), compiling Java...\n");

      const compileResult = compiler.compile();
      addToTerminal(`Java compilation result: ${compileResult}\n`);

      if (compileResult) {
        addToTerminal("Generating WebAssembly...\n");

        try {
          compiler.generateWebAssembly({
            outputName: "app",
            mainClass: "Main",
          });
          addToTerminal("WebAssembly generation completed\n");

          const wasmBytes = compiler.getWebAssemblyOutputFile("app.wasm");
          if (wasmBytes && wasmBytes.length > 0) {
            addToTerminal(`WebAssembly module: ${wasmBytes.length} bytes\n`);

            // Load c.js in the parent window first, then pass to iframe
            try {
              addToTerminal("Loading c.js module...\n");
              const { load } = await import('./c.js');
              
              // Create Blob URL for WASM
              const wasmBlob = new Blob([wasmBytes], { type: 'application/wasm' });
              const wasmUrl = URL.createObjectURL(wasmBlob);

              // Create HTML with injected input and output capture
              const inputJSON = JSON.stringify(userInput || "");
              
              // Run in parent window, display output in iframe
              addToTerminal("Running WebAssembly...\n");
              
              let capturedOutput = '';
              const originalLog = console.log;
              const originalError = console.error;
              
              console.log = function(...args) {
                const line = args.join(' ');
                capturedOutput += line + '\n';
                originalLog.apply(console, args);
              };
              
              console.error = function(...args) {
                const line = args.join(' ');
                capturedOutput += line + '\n';
                originalError.apply(console, args);
              };

              // Fetch and run WASM
              const wasmResponse = await fetch(wasmUrl);
              const wasmArrayBuffer = await wasmResponse.arrayBuffer();
              const runtime = await load(new Uint8Array(wasmArrayBuffer));

              if (runtime.exports && typeof runtime.exports.main === 'function') {
                try {
                  runtime.exports.main([]);
                  addToTerminal("Program execution completed\n");
                } catch(runErr) {
                  capturedOutput += 'Runtime error: ' + (runErr.message || String(runErr)) + '\n';
                  addToTerminal("Runtime error: " + (runErr.message || String(runErr)) + "\n");
                }
              } else {
                capturedOutput += 'Error: No main method found\n';
                addToTerminal("No main method found in exports\n");
              }

              console.log = originalLog;
              console.error = originalError;

              // Display output in preview iframe
              const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <style>
    body {
      background: #0f0f0f;
      color: #dcdcdc;
      font-family: 'Consolas', 'Monaco', monospace;
      padding: 12px;
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 13px;
      line-height: 1.5;
    }
  </style>
</head>
<body>${capturedOutput.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>")}</body>
</html>`;

              const previewFrame = document.getElementById("preview-frame");
              if (previewFrame) {
                previewFrame.srcdoc = htmlContent;
              }

              // Clean up blob URL
              URL.revokeObjectURL(wasmUrl);

              // Trigger validation
              if (expectedOutput && expectedOutput.trim()) {
                const cmp = compareOutputs(capturedOutput, expectedOutput);
                setVerdict(cmp.ok ? { ok: true, message: "Passed" } : { ok: false, message: "Failed" });
                
                addToTerminal("\n=== Output Validation ===\n");
                if (cmp.ok) {
                  addToTerminal("✓ Output matches expected output (PASSED)\n");
                } else {
                  addToTerminal("✗ Output does not match expected output (FAILED)\n");
                  addToTerminal("\n--- Expected (normalized) ---\n'" + cmp.expected + "'\n");
                  addToTerminal("\n--- Actual (normalized) ---\n'" + cmp.actual + "'\n");
                  if (capturedOutput.trim() === '') {
                    addToTerminal("\n⚠️  WARNING: Actual output is empty!\n");
                  }
                }
                addToTerminal("========================\n\n");
              }

              addToTerminal("✓ Preview updated with program output\n");
              setStatus("Execution finished");
              addToTerminal("=== Program finished ===\n");
            } catch(loadError) {
              addToTerminal("Failed to load or run WASM: " + (loadError.message || String(loadError)) + "\n");
              setStatus("Execution failed");
            }
          } else {
            addToTerminal("No WebAssembly output found\n");
          }
        } catch (generateError) {
          setStatus("Generation failed");
          addToTerminal("Generation failed: " + (generateError && generateError.message ? generateError.message : String(generateError)) + "\n");
        }
      } else {
        setStatus("Java compilation failed");
        addToTerminal("Java compilation failed\n");

        if (diagnostics.length > 0) {
          addToTerminal("\nDiagnostics:\n");
          diagnostics.forEach((d) => addToTerminal(`${d.severity}: ${d.message}\n`));
        }
      }

      if (listener && listener.destroy) listener.destroy();
    } catch (error) {
      setStatus("Compilation error: " + (error && error.message ? error.message : String(error)));
      addToTerminal("Compilation error: " + (error && error.message ? error.message : String(error)) + "\n");
      addToTerminal("Stack trace: " + (error && error.stack ? error.stack : "") + "\n");
      console.error("Compilation error:", error);
    }
  };

  const handleCodeChange = (value) => {
    setJavaCode(value || '');
    if (currentFile) {
      setHasUnsavedChanges(true);
    }
  };

  const saveFile = async () => {
    if (!currentFile || !currentFile.id) {
      alert('No file is currently open');
      return;
    }

    try {
      await fileAPI.updateFile(currentFile.id, javaCode);
      setHasUnsavedChanges(false);
      addToTerminal(`File saved: ${currentFile.name}\n`);
    } catch (error) {
      console.error('Error saving file:', error);
      alert('Failed to save file');
    }
  };

  const goToDashboard = () => {
    if (hasUnsavedChanges) {
      const confirmLeave = window.confirm('You have unsaved changes. Do you want to leave without saving?');
      if (!confirmLeave) return;
    }
    navigate('/dashboard');
  };

  const clearInput = () => setUserInput("");
  const clearExpected = () => {
    setExpectedOutput("");
    setVerdict(null);
  };

  if (showLoader) {
    return (
      <div className="codii-loader-container">
        <img src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png" alt="Codii Logo" className="codii-loader-logo" />
        <div className="codii-progress-bar"><div className="codii-progress-fill" /></div>
        <div className="codii-loader-text">Initializing your coding space...</div>
      </div>
    );
  }

  return (
    <div id="app-root" style={{ height: "100vh" }}>
      <div id="main">
        <div id="topbar">
          <div id="title">
            <img
              id="logo"
              src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png"
              alt="logo"
              onClick={goToDashboard}
              style={{ cursor: 'pointer' }}
              title="Back to Dashboard"
            />
            {currentFile && (
              <span style={{ marginLeft: '10px', fontSize: '14px', color: '#888' }}>
                {currentFile.name} {hasUnsavedChanges && '*'}
              </span>
            )}
          </div>
          <div id="actions">
            {currentFile && (
              <button
                onClick={saveFile}
                style={{
                  marginRight: '8px',
                  background: hasUnsavedChanges ? '#00d084' : '#555',
                }}
              >
                {hasUnsavedChanges ? 'Save *' : 'Save'}
              </button>
            )}
            <button id="compile" onClick={compileJava} disabled={!isInitialized}>Compile</button>
          </div>
        </div>

        <div id="main-grid">
          <div id="col-editor" className="col">
            <div className="panel-header">Editor</div>
            <div id="editor" className="panel-body" style={{ minHeight: 0 }}>
              <Editor
                height="100%"
                language="java"
                theme="vs-dark"
                value={javaCode}
                onChange={handleCodeChange}
                options={editorOptions}
              />
            </div>
          </div>

          <div id="col-center" className="col">
            <div id="center-top" className="half">
              <div className="panel-header">
                Program Input <small>(optional)</small>
                <div className="header-controls">
                  <button id="clear-input" title="Clear input" onClick={clearInput}>Clear</button>
                </div>
              </div>
              <textarea id="stdin-input" className="panel-body textarea" value={userInput} onChange={(e) => setUserInput(e.target.value)} />
            </div>

            <div id="center-bottom" className="half">
              <div className="panel-header">
                Preview
                <div className="header-controls">
                  <div id="validation-status" style={{ display: 'none' }}>
                    <div id="validation-result" className="validation-result"></div>
                  </div>
                </div>
              </div>
              <div id="preview-area" className="panel-body" style={{ padding: 0 }}>
                <iframe id="preview-frame" title="preview" style={{ width: "100%", height: "100%", border: 0 }} />
              </div>
            </div>
          </div>

          <div id="col-expected" className="col">
            <div id="expected-top" className="half">
              <div className="panel-header">
                Expected Output
                <div className="header-controls">
                  <button id="clear-expected" title="Clear expected output" onClick={clearExpected}>Clear</button>
                </div>
              </div>
              <textarea id="expected-output" className="panel-body textarea" value={expectedOutput} onChange={(e) => setExpectedOutput(e.target.value)} />
            </div>

            <div id="expected-bottom" className="half">
              <div className="panel-header">Terminal Output</div>
              <div id="terminal-attach" className="panel-body terminal-attach" style={{ padding: 0 }}>
                <textarea
                  ref={terminalRef}
                  readOnly
                  value={terminalOutput}
                  style={{
                    width: "100%",
                    height: "100%",
                    resize: "none",
                    background: "#070707",
                    color: "#e6e6e6",
                    border: "none",
                    padding: 8,
                    fontFamily: "JetBrains Mono, monospace",
                    fontSize: 13,
                    outline: "none",
                    whiteSpace: "pre"
                  }}
                />
              </div>
              <div
                id="status"
                className="status"
                style={verdict ? { background: verdict.ok ? "green" : "red" } : {}}
              >
                {verdict ? verdict.message : status}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}